import type { PackLocale } from '../features'
import type { MkPack } from './types'
import de from './de'
import es from './es'
import uk from './uk'

export const PACKS: Record<PackLocale, MkPack> = { de, es, uk }
